import { styled } from "@material-ui/core";

export const HeaderStatsContainer = styled("div")(({ theme }) => ({
  justifyContent: "space-between",
  alignItems: "stretch",
  display: "flex",
  width: "100%",

  "& > *:not(:last-child)": {
    marginRight: theme.spacing(2),
  },
}));



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolProfileView/components/HeaderStats/HeaderStats.styles.js